const constants = {
    auth: {
        accessTokenDuration: "15m",
        refreshTokenDuration: "7d",
        accessTokenExpiryIntervalDuration: (15 * 60 * 1000),
    },
    dashboard: {
        colors: ['#3B82F6', '#FFBB28', '#FF8042', '#EF4444', '#8C2264', '#003C73', '#4B9960', '#F87171'],
    },
    tableUI: {
        defaultPerpage: 5, // defaultPerPage
        perPageOptions: [5, 10, 15, 20]
    },
    filters: {
        debounceInterval: 500
    },
    upload: {
        max_file_size: 200 * 1024 * 1024, // 200MB
        statusList: ['Uploading', 'Uploaded'],
        titles: {1: "Upload Details", 2: "File Selection", 3: "Field Mapping"},
        filtersInitialState: { keyword: "", sourceType: "",  masterProject: "", project: "", vendor: "", channelPartner:"", spoc: "", dataCategory: "", leadSource: "", status: "", start_date: "", end_date: "", pending: "" },
        dataInitialState: { sourceType: "", masterProject: "", project: "", vendor: "", channelPartner:"", spoc: "", dataCategory: "", leadSource: "", uploadedBy: "", extractedOn: null, procReason: "", fileRowCount: 0, fileColCount: 0, fileSizeInMB: 0, columnMapping: {}},
        errorInitialState: { sourceType: "", masterProject: "", project: "", vendor: "", channelPartner:"", spoc: "", dataCategory: "", leadSource: "", uploadedBy: "", extractedOn: "", procReason: "", remarks: "", file: { type: "", size: "", count: "" }, mappedColumns: [], selectedColumns: []},
        matchNotFound : "Match not found",
        simulated: false,
        fieldMappingTimeout: 60000, // 1 minute
        tooltipTexts: {
            sourceType: 'Select the source of the uploaded data',
            masterProject: 'Select the master project that oversees this item',
            project: 'Choose the associated project for this entry',
            vendor: 'Pick the vendor who provided the data',
            spoc: 'Specify the Single Point of Contact (SPOC)',
            uploadedBy: 'Name of the person who uploaded the data',
            dataCategory: 'Choose the category this data falls under',
            leadSource: 'Indicate where the lead originated from',
            extractedOn: 'The date when data was extracted',
            procReason: 'Mention why this data was procured'
        },
        cardHeight: '25rem',
    },
    extraction: {
        dataInitialState: { 
            id: null,
            title: "Untitled",
            masterProject: "", 
            project: "", 
            addTemporaryValues: false, 
            tempMasterProject: "", 
            tempProject: "",
            approxStartingPrice: "0",
            pincode: "",
        },
        errorInitialState: { 
            masterProject: "", 
            project: "", 
            tempMasterProject: "",
            tempProject: ""
        },
        listInitialState: { 
            data: [], 
            pagination: { 
              currentPage: 1, 
              perPage: 5, // defaultPerPage
              total: 0 
            }
        },
        fullDataListInitialState: { 
            data: [], 
            pagination: { 
              currentPage: 1, 
              perPage: 10,
              total: 0 
            }
        },
        initialState: {
            extVersion: { selected_columns: [], custom_columns: [], loading: false, is_default: true },
            extCustomColumn: { title: "", used_fields: [], replace_with: [], groups: []},
            mcc: {
                campaign_name: '',
                file: null,
                vendors: [{ vendor_name: '', lead_list_id: '', lead_list_name: '' }],
                is_scheduled: false,
                scheduled_date: '',
                scheduled_time: '',
            }
        },
        tooltipTexts: {
            masterProject: 'Select the master project that oversees this extraction',
            project: 'Choose the associated project for this extraction',
            approxStartingPrice: 'Provide an estimated starting price for this extraction',
            pincode: 'Enter the pincode relevant to this extraction'
        },
        mandatoryColumns: ['ProfileID', 'DNCFlag'],
        extVersion: {
            polling: {
                maxTotalTime: 1800000, // 30 minutes
                interval: 120000  // 2 minutes
            }
        },
        parquetIngestion: {
            initialDelay: 7000, // 7 seconds
            pollInterval: 2000 // 2 seconds
        }
    }
}

export default constants;